import React, { useEffect, useState } from "react";
import {
  Card,
  Text,
  CardHeader,
  CardContent,
  CardTitle,
  Button,
} from "@netapp/bxp-design-system-react";
import {
  NoticeIcon,
  ProtectedIcon,
} from "@netapp/bxp-style/react-icons/Notification";
import { ExternalLinkIcon } from "@netapp/bxp-style/react-icons/Navigation";
import "./Frame2.scss";
import { useLangNavigate } from "../../../../utils/langNavigation";
import { useTranslation } from "react-i18next";
import SubscribeModal from "../../../../Components/Subscribe_modal/Subscribe";
import { ChatIcon } from "@netapp/bxp-style/react-icons/Action";
import OtpModal from "../../../../Components/Subscribe_modal/OtpModal";
import { getContentPath, loadMarkdownContent } from "../../../../utils/contentLoader";

function Frame2({ notification, setNotification }) {
  const navigate = useLangNavigate();
  const { i18n, t } = useTranslation();
  const [advisoryData, setAdvisoryData] = useState({});
  const [policyData, setPolicyData] = useState({});
  const [isSubscribeModalOpen, setIsSubscribeModalOpen] = useState(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubscriptionSuccess = (email) => {
    setEmail(email);
    setIsSubscribeModalOpen(false);
    setIsOtpModalOpen(true);
  };

  useEffect(() => {
    async function loadData() {
      try {
        const advisoryPath = getContentPath("/content/advisory/_index", i18n.language);
        const policyPath = getContentPath("/content/policy/_index", i18n.language);

        const [advisoryResult, policyResult] = await Promise.all([
          loadMarkdownContent(advisoryPath),
          loadMarkdownContent(policyPath),
        ]);

        setAdvisoryData(advisoryResult.frontMatter);
        setPolicyData(policyResult.frontMatter);
      } catch (error) {
        console.error("Error fetching markdown files:", error);
      }
    }
    loadData();
  }, [i18n.language]);

  return (
    <section className="frame2" aria-labelledby="frame2-title">
      <div className="innerFrame2">
        {/* Security Advisories Card (full width) */}
        <Card className="securityAdvisoriesCard">
          <CardHeader>
            <CardTitle id="frame2-title" className="card-title">
              <NoticeIcon />
              <span style={{ marginLeft: "8px" }}>
                {advisoryData.longtitle}
              </span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Text className="card-text">{advisoryData.description}</Text>
            <div className="securityAdvisoriesCardButtonsFrame">
              <Button onClick={() => navigate("/advisory")}>
                {t("see_all_security_advisories.other")}
              </Button>
              <Button
                color="secondary"
                onClick={() => setIsSubscribeModalOpen(true)}
              >
                {t("subscribe_to_all_advisory_updates.other")}
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Two mid cards (Policy + Report) */}
        <div className="frame2-card-div">
          <Card className="mid-card">
            <CardHeader type="small">
              <CardTitle className="card-title2">
                <ProtectedIcon />
                <span style={{ marginLeft: "8px" }}>
                  {t("netapp_security_policy.other")}
                </span>
              </CardTitle>
            </CardHeader>
            <Text className="card-text">{policyData.description}</Text>
            <Button
              variant="text"
              className="link-button"
              onClick={() => {
                window.location.href = "/policy";
              }}
            >
              {t("view_policy.other")}
              <ExternalLinkIcon />
            </Button>
          </Card>

          <Card className="mid-card">
            <CardHeader type="small">
              <CardTitle className="card-title2">
                <ChatIcon />
                <span style={{ marginLeft: "8px" }}>
                  {t("report_an_issue.other")}
                </span>
              </CardTitle>
            </CardHeader>
            <Text className="card-text">
              {t("report_issue_description.other")}
            </Text>
            <Button
              variant="text"
              className="link-button"
              onClick={() => {
                window.location.href = "/report";
              }}
            >
              {t("report_an_issue.other")}
              <ExternalLinkIcon />
            </Button>
          </Card>
        </div>
      </div>

      {isSubscribeModalOpen && (
        <SubscribeModal
          advisoryId="ntap_all"
          open={isSubscribeModalOpen}
          headerText={t("subscribe_to_all_advisory_updates.other")}
          onSubscriptionSuccess={handleSubscriptionSuccess}
          setOpen={setIsSubscribeModalOpen}
          notification={notification}
          setNotification={setNotification}
        />
      )}

      {isOtpModalOpen && (
        <OtpModal
          email={email}
          advisoryId="ntap_all"
          notification={notification}
          setNotification={setNotification}
          onClose={() => setIsOtpModalOpen(false)}
        />
      )}
    </section>
  );
}

export default Frame2;